const ACCESS_TOKEN_KEY = 'ato'
const REFRESH_TOKEN_KEY = 'rto'
const LANG_KEY = 'lang'

export {
    ACCESS_TOKEN_KEY,
    REFRESH_TOKEN_KEY,
    LANG_KEY
}